import styled from 'styled-components';
export const StyledSelect = styled.div`
  width: 100%;
  height: fit-content;
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  z-index: 2;
  position: relative;
  overflow: hidden;
`;

export const ToggleSelect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 78px;
  z-index: 9999999;
`;

export const SelectContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

type IconProps = {
  size?: number;
  color?: string;
};

export const SelectIconWrapper = styled.div<IconProps>`
  & svg {
    font-size: ${(props) => props.size}px;

    path {
      fill: ${(props) => props.color};
    }
  }
`;

export const SelectTextContent = styled.div`
  margin-left: 15px;
  overflow: hidden;
  flex: 1;
`;

export const SelectLabel = styled.span`
  height: 20px;
  opacity: 0.5;
  font-size: 12px;
  font-weight: bold;
  text-overflow: ellipsis;
`;

export const SelectBoxIcon = styled.div`
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

export const SelectInput = styled.input`
  width: 90%;
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
  text-overflow: ellipsis;
  caret-color: ${({ theme }) => theme.palette.coral};
  border: none;
  outline: none;
  padding: 0;
  font-size: 16px;
  position: relative;
  z-index: 999999999;

  &::placeholder {
    opacity: 1;
    font-size: 16px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: ${({ theme }) => theme.palette.matterHorn};
  }
`;
